export interface IFavoritesState {
  count: number;
  entityTypes: TFavoriteEntityType;
  favorites: IFavorite[];
  status: EFavoritesStatus;
}

export interface IFavorite {
  entityId: number;
  title: string;
  geo: IGeo;
  photoFullUrl: string | null;
  price: string | null;
  entityType: TFavoriteEntityType;
  fullUrl: string;
}

export type TFavoriteEntityType = 'newbuilding' | 'ads';

export enum EEntityType {
  Commercial = 'commercial',
  Newbuilding = 'newbuilding',
  Residential = 'residential',
  Suburban = 'suburban',
}

export interface IGeo {
  address: IAddressInfo[];
  regionId?: number | null;
  undergrounds: IUndergroundInfo[];
}

export interface IAddressInfo {
  fullUrl?: string | null;
  title?: string | null;
}

export interface IUndergroundInfo {
  fullUrl?: string | null;
  isDefault: boolean;
  lineColor?: string | null;
  name: string;
  releaseYear?: number | null;
  time?: number | null;
  transportType?: ETransportType | null;
  underConstruction: boolean;
}

export enum ETransportType {
  Transport = 'transport',
  Walk = 'walk',
}

export enum EFavoritesStatus {
  Initial = 'initial',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}
